// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableLoadingSpinner_spinnerBackdrop__zjNQn {
  height: 492px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  border-radius: 15px;
  /* From https://css.glass */
  background: rgba(241, 241, 241, 0.57);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(7.5px);
  -webkit-backdrop-filter: blur(7.5px);
}

.TableLoadingSpinner_spinnerBackdrop__zjNQn h2 {
  font-size: 1.8rem;
  padding: 10px 0 20px 0;
}
.TableLoadingSpinner_spinnerBackdrop__zjNQn h3 {
  font-size: 1.2rem;
  padding: 10px 0 20px 0;
}

.TableLoadingSpinner_spinnerContainer__35Yzw {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.TableLoadingSpinner_spinnerContainer__35Yzw div {
  position: absolute;
  width: 6px;
  height: 6px;
  background: #353e54;
  border-radius: 50%;
  animation: TableLoadingSpinner_spinnerContainer__35Yzw 1.2s linear infinite;
}
.TableLoadingSpinner_spinnerContainer__35Yzw div:nth-child(1) {
  animation-delay: 0s;
  top: 37px;
  left: 66px;
}
.TableLoadingSpinner_spinnerContainer__35Yzw div:nth-child(2) {
  animation-delay: -0.1s;
  top: 22px;
  left: 62px;
}
.TableLoadingSpinner_spinnerContainer__35Yzw div:nth-child(3) {
  animation-delay: -0.2s;
  top: 11px;
  left: 52px;
}
.TableLoadingSpinner_spinnerContainer__35Yzw div:nth-child(4) {
  animation-delay: -0.3s;
  top: 7px;
  left: 37px;
}
.TableLoadingSpinner_spinnerContainer__35Yzw div:nth-child(5) {
  animation-delay: -0.4s;
  top: 11px;
  left: 22px;
}
.TableLoadingSpinner_spinnerContainer__35Yzw div:nth-child(6) {
  animation-delay: -0.5s;
  top: 22px;
  left: 11px;
}
.TableLoadingSpinner_spinnerContainer__35Yzw div:nth-child(7) {
  animation-delay: -0.6s;
  top: 37px;
  left: 7px;
}
.TableLoadingSpinner_spinnerContainer__35Yzw div:nth-child(8) {
  animation-delay: -0.7s;
  top: 52px;
  left: 11px;
}
.TableLoadingSpinner_spinnerContainer__35Yzw div:nth-child(9) {
  animation-delay: -0.8s;
  top: 62px;
  left: 22px;
}
.TableLoadingSpinner_spinnerContainer__35Yzw div:nth-child(10) {
  animation-delay: -0.9s;
  top: 66px;
  left: 37px;
}
.TableLoadingSpinner_spinnerContainer__35Yzw div:nth-child(11) {
  animation-delay: -1s;
  top: 62px;
  left: 52px;
}
.TableLoadingSpinner_spinnerContainer__35Yzw div:nth-child(12) {
  animation-delay: -1.1s;
  top: 52px;
  left: 62px;
}

@keyframes TableLoadingSpinner_spinnerContainer__35Yzw {
  0%,
  20%,
  80%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/NewTable/TableLoadingSpinner/TableLoadingSpinner.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;EACrC,yCAAyC;EACzC,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,2EAAgD;AAClD;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;;;;IAIE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".spinnerBackdrop {\r\n  height: 492px;\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  width: 100%;\r\n  border-radius: 15px;\r\n  /* From https://css.glass */\r\n  background: rgba(241, 241, 241, 0.57);\r\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\r\n  backdrop-filter: blur(7.5px);\r\n  -webkit-backdrop-filter: blur(7.5px);\r\n}\r\n\r\n.spinnerBackdrop h2 {\r\n  font-size: 1.8rem;\r\n  padding: 10px 0 20px 0;\r\n}\r\n.spinnerBackdrop h3 {\r\n  font-size: 1.2rem;\r\n  padding: 10px 0 20px 0;\r\n}\r\n\r\n.spinnerContainer {\r\n  display: inline-block;\r\n  position: relative;\r\n  width: 80px;\r\n  height: 80px;\r\n}\r\n.spinnerContainer div {\r\n  position: absolute;\r\n  width: 6px;\r\n  height: 6px;\r\n  background: #353e54;\r\n  border-radius: 50%;\r\n  animation: spinnerContainer 1.2s linear infinite;\r\n}\r\n.spinnerContainer div:nth-child(1) {\r\n  animation-delay: 0s;\r\n  top: 37px;\r\n  left: 66px;\r\n}\r\n.spinnerContainer div:nth-child(2) {\r\n  animation-delay: -0.1s;\r\n  top: 22px;\r\n  left: 62px;\r\n}\r\n.spinnerContainer div:nth-child(3) {\r\n  animation-delay: -0.2s;\r\n  top: 11px;\r\n  left: 52px;\r\n}\r\n.spinnerContainer div:nth-child(4) {\r\n  animation-delay: -0.3s;\r\n  top: 7px;\r\n  left: 37px;\r\n}\r\n.spinnerContainer div:nth-child(5) {\r\n  animation-delay: -0.4s;\r\n  top: 11px;\r\n  left: 22px;\r\n}\r\n.spinnerContainer div:nth-child(6) {\r\n  animation-delay: -0.5s;\r\n  top: 22px;\r\n  left: 11px;\r\n}\r\n.spinnerContainer div:nth-child(7) {\r\n  animation-delay: -0.6s;\r\n  top: 37px;\r\n  left: 7px;\r\n}\r\n.spinnerContainer div:nth-child(8) {\r\n  animation-delay: -0.7s;\r\n  top: 52px;\r\n  left: 11px;\r\n}\r\n.spinnerContainer div:nth-child(9) {\r\n  animation-delay: -0.8s;\r\n  top: 62px;\r\n  left: 22px;\r\n}\r\n.spinnerContainer div:nth-child(10) {\r\n  animation-delay: -0.9s;\r\n  top: 66px;\r\n  left: 37px;\r\n}\r\n.spinnerContainer div:nth-child(11) {\r\n  animation-delay: -1s;\r\n  top: 62px;\r\n  left: 52px;\r\n}\r\n.spinnerContainer div:nth-child(12) {\r\n  animation-delay: -1.1s;\r\n  top: 52px;\r\n  left: 62px;\r\n}\r\n\r\n@keyframes spinnerContainer {\r\n  0%,\r\n  20%,\r\n  80%,\r\n  100% {\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    transform: scale(1.5);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinnerBackdrop": `TableLoadingSpinner_spinnerBackdrop__zjNQn`,
	"spinnerContainer": `TableLoadingSpinner_spinnerContainer__35Yzw`
};
export default ___CSS_LOADER_EXPORT___;
